<template>
    <div v-if="easyFlowVisible" style="height: calc(100vh);" v-loading="loading">
        <el-row>
            <!--顶部工具菜单-->
            <el-col :span="24">
                <div class="ef-tooltar">
                    <!-- <el-link type="primary">{{data.name}}</el-link> -->
                    <el-button type="text">{{data.name}}</el-button>
                    <!-- <el-divider direction="vertical"></el-divider> -->
                    <el-button type="text" icon="el-icon-delete" size="large" @click="deleteElement" :disabled="!this.activeElement.type"></el-button>
                    <!-- <el-divider direction="vertical"></el-divider> -->
                    <el-button type="text" icon="el-icon-download" size="large" @click="downloadData"></el-button>
                    <!-- <el-divider direction="vertical"></el-divider> -->
                    <el-button type="text" icon="el-icon-plus" size="large" @click="zoomAdd"></el-button>
                    <!-- <el-divider direction="vertical"></el-divider> -->
                    <el-button type="text" icon="el-icon-minus" size="large" @click="zoomSub"></el-button>
                    <el-button type="text" icon="el-icon-refresh" size="large" @click="refreshPanel"></el-button>
                    <div style="float: right;margin-right: 5px">
                        <el-button type="success" plain round icon="el-icon-document" @click="addFlowChart" size="mini">保存流程图</el-button>
                        <el-button type="info" plain round icon="el-icon-document" @click="openHelp" size="mini">帮助</el-button>
                    </div>
                    <div style="float: right;margin-right: 108px">
                        <!-- <el-button type="success" plain round icon="el-icon-document" @click="dataInfo" size="mini">流程信息</el-button> -->
                        <el-button type="primary" plain round v-for="item in sceneList" :key="item.id"  @click="dataReloadButton(item)"> {{item.sceneName}}</el-button>
                        <!-- <el-button type="primary" plain round @click="dataReloadA" icon="el-icon-refresh" size="mini">首次电联</el-button>
                        <el-button type="primary" plain round @click="dataReloadB" icon="el-icon-refresh" size="mini">PTP超时</el-button>
                        <el-button type="primary" plain round @click="dataReloadC" icon="el-icon-refresh" size="mini">施压</el-button> -->
                        <!-- <el-button type="primary" plain round @click="dataReloadD" icon="el-icon-refresh" size="mini">自定义样式</el-button> -->
                    </div>
                </div>
            </el-col>
        </el-row>
        <div style="display: flex;height: calc(100% - 47px);">
            <div style="width: 200px;height: 90%;border-right: 1px solid #dce3e8;overflow-y:scroll">
                <node-menu @addNode="addNode" ref="nodeMenu" :templateList="templateList"></node-menu>
            </div>
            <div id="efContainer" ref="efContainer" class="container" v-flowDrag>
                <template v-for="node in data.nodeList">
                    <flow-node
                            :id="node.id"
                            :key="node.id"
                            :node="node"
                            :title="node.title"
                            :filePath="node.filePath"
                            :content="node.content"
                            :contentTrans="node.contentTrans"
                            :activeElement="activeElement"
                            @changeNodeSite="changeNodeSite"
                            @nodeRightMenu="nodeRightMenu"
                            @clickNode="clickNode"

                    >
                    </flow-node>
                </template>
                <!-- 给画布一个默认的宽度和高度 -->
                <div style="position:absolute;top: 2000px;left: 3000px;">&nbsp;</div>
            </div>
            <!-- 右侧表单 -->
            <div style="width: 250px;border-left: 1px solid #dce3e8;background-color: #FBFBFB">
                <flow-node-form ref="nodeForm" @setLineLabel="setLineLabel" @repaintEverything="repaintEverything"></flow-node-form>
            </div>
        </div>
        <!-- 流程数据详情 -->
        <flow-info v-if="flowInfoVisible" ref="flowInfo" :data="data"></flow-info>
        <flow-help v-if="flowHelpVisible" ref="flowHelp"></flow-help>
    </div>

</template>

<script>
import lodash from 'lodash';
import draggable from 'vuedraggable';
// import jsPlumbs from 'jsplumb';
// 使用修改后的jsplumb
import './ef/jsplumb';
import easyFlowMixin from './ef/mixins';
import flowNode from './ef/node';
import nodeMenu from './ef/node_menu';
import FlowInfo from './ef/info';
import FlowHelp from './ef/help';
import FlowNodeForm from './ef/node_form';

export default {
  props: {
    changeTabe: {
      type: String
    },
    companySelected: {
    },
    groupSelected: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '场景流程') {
        this.getSceneTemplates();
        // eslint-disable-next-line no-undef
        this.jsPlumb = jsPlumb.getInstance();
      }
    },
    companySelected(companyId) {
      this.params.companyId = companyId;
    },
    groupSelected(groupId) {
      this.params.groupId = groupId;
      if (this.changeTabe === '场景流程') {
        this.getSceneTemplates();
        // eslint-disable-next-line no-undef
        this.jsPlumb = jsPlumb.getInstance();
      }
    }
  },
  data() {
    return {
      params: {
        companyId: null,
        groupId: null,
        type: 'ivr',
        recorderId: null
      },
      // jsPlumb 实例
      jsPlumb: null,
      // 控制画布销毁
      easyFlowVisible: true,
      loading: false,
      // 控制流程数据显示与隐藏
      flowInfoVisible: false,
      // 是否加载完毕标志位
      loadEasyFlowFinish: false,
      flowHelpVisible: false,
      // 数据
      data: {},
      // 激活的元素、可能是节点、可能是连线
      activeElement: {
        // 可选值 node 、line
        type: undefined,
        // 节点ID
        nodeId: undefined,
        // 连线ID
        sourceId: undefined,
        targetId: undefined,
        name: null
      },
      // 场景列表
      sceneList: [],
      // 可用模板列表
      templateList: [],
      // 数据
      dataAll: {},
      zoom: 1,
      sceneId: null
    };
  },
  // 一些基础配置移动该文件中
  mixins: [easyFlowMixin],
  components: {
    draggable, flowNode, nodeMenu, FlowInfo, FlowNodeForm, FlowHelp
  },
  directives: {
    'flowDrag': {
      bind(el, binding, vnode, oldNode) {
        console.warn(oldNode);
        if (!binding) {
          return;
        }
        el.onmousedown = (e) => {
          if (e.button === 2) {
            // 右键不管
            return;
          }
          // 鼠标按下，计算当前原始距离可视区的高度
          const disX = e.clientX;
          const disY = e.clientY;
          el.style.cursor = 'move';

          document.onmousemove = function bar(s) {
            // 移动时禁止默认事件
            s.preventDefault();
            const left = s.clientX - disX;
            // disX = e.clientX;
            el.scrollLeft += -left;

            const top = s.clientY - disY;
            // disY = s.clientY;
            el.scrollTop += -top;
          };

          document.onmouseup = function bar() {
            el.style.cursor = 'auto';
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods: {
    refreshPanel() {
      this.easyFlowVisible = true;
      // eslint-disable-next-line no-undef
      this.jsPlumb = jsPlumb.getInstance();
      this.dataReload({});
      this.dataReloadAll(this.sceneId);
    },
    // 获取场景
    getSceneTemplates() {
      this.$ajax({
        url: '/scene/getSceneTemplates',
        method: 'post',
        data: this.params
      }).then((res) => {
        this.sceneList = res.data;
        const flowChartId = sessionStorage.getItem('flowChartId');
        if (flowChartId) {
          this.dataReloadAll(flowChartId);
          sessionStorage.removeItem('flowChartId');
        } else if (this.sceneList.length > 0) {
          this.dataReloadAll(this.sceneList[0].id);
          this.params.recorderId = this.sceneList[0].recorderId;
          this.getTemplates();
        } else {
          this.dataAll = {};
          this.dataReload(this.dataAll);
          this.loading = false;
        }
      });
    },
    // 获取可用模板
    getTemplates() {
      this.$ajax({
        url: '/scene/getTemplateByCompanyId',
        method: 'post',
        data: this.params
      }).then((res) => {
        console.warn(res);
        this.templateList = res.data;
      });
    },
    dataReloadButton(item) {
      this.params.recorderId = item.recorderId;
      this.getTemplates();
      this.dataReloadAll(item.id);
    },
    // 获取流程图数据
    dataReloadAll(id) {
      this.sceneId = id;
      // this.loading = true;
      this.dataAll = {};
      this.$ajax({
        url: '/scene/getFlowChart',
        method: 'post',
        data: {
          sceneId: id
        }
      }).then((res) => {
        console.warn(res);
        this.dataAll = res.data;
        this.dataReload(this.dataAll);
        this.loading = false;
      });
    },
    // 保存流程图
    addFlowChart() {
      this.loading = true;
      this.$ajax({
        url: '/scene/addFlowChart',
        method: 'post',
        prompt: true,
        data: this.data
      }).then((res) => {
        console.warn(res);
      }).finally(() => {
        this.loading = false;
      });
    },
    // 返回唯一标识
    getUUID() {
      return Math.random().toString(36).substr(3, 10);
    },
    jsPlumbInit() {
      this.jsPlumb.ready(() => {
        // 导入默认配置
        this.jsPlumb.importDefaults(this.jsplumbSetting);
        // 会使整个jsPlumb立即重绘。
        this.jsPlumb.setSuspendDrawing(false, true);
        // 初始化节点
        this.loadEasyFlow();
        // 单点击了连接线, https://www.cnblogs.com/ysx215/p/7615677.html
        this.jsPlumb.bind('click', (conn, originalEvent) => {
          console.warn(originalEvent);
          this.activeElement.type = 'line';
          this.activeElement.sourceId = conn.sourceId;
          this.activeElement.targetId = conn.targetId;
          this.$refs.nodeForm.lineInit({
            from: conn.sourceId,
            to: conn.targetId,
            label: conn.getLabel() === '' || conn.getLabel() === null || conn.getLabel() === undefined ? [] : conn.getLabel().split(',')
          });
        });
        // 连线
        this.jsPlumb.bind('connection', (evt) => {
          const from = evt.source.id;
          const to = evt.target.id;
          if (this.loadEasyFlowFinish) {
            this.data.lineList.push({ from, to });
          }
        });

        // 删除连线回调
        this.jsPlumb.bind('connectionDetached', (evt) => {
          this.deleteLine(evt.sourceId, evt.targetId);
        });

        // 改变线的连接节点
        this.jsPlumb.bind('connectionMoved', (evt) => {
          this.changeLine(evt.originalSourceId, evt.originalTargetId);
        });

        // 连线右击
        this.jsPlumb.bind('contextmenu', (evt) => {
          console.warn('contextmenu', evt);
        });

        // 连线
        this.jsPlumb.bind('beforeDrop', (evt) => {
          const from = evt.sourceId;
          const to = evt.targetId;
          if (from === to) {
            this.$message.error('节点不支持连接自己');
            return false;
          }
          if (this.hasLine(from, to)) {
            this.$message.error('该关系已存在,不允许重复创建');
            return false;
          }
          if (this.hashOppositeLine(from, to)) {
            this.$message.error('不支持两个节点之间连线回环');
            return false;
          }
          this.$message.success('连接成功');
          return true;
        });

        // beforeDetach
        this.jsPlumb.bind('beforeDetach', (evt) => {
          console.warn('beforeDetach', evt);
        });
        this.jsPlumb.setContainer(this.$refs.efContainer);
      });
    },
    // 加载流程图
    loadEasyFlow() {
      // 初始化节点
      for (let i = 0; i < this.data.nodeList.length; i++) {
        const node = this.data.nodeList[i];
        // 设置源点，可以拖出线连接其他节点
        this.jsPlumb.makeSource(node.id, lodash.merge(this.jsplumbSourceOptions, {}));
        // // 设置目标点，其他源点拖出的线可以连接该节点
        this.jsPlumb.makeTarget(node.id, this.jsplumbTargetOptions);
        if (!node.viewOnly) {
          this.jsPlumb.draggable(node.id, {
            containment: 'parent',
            stop(el) {
              // 拖拽节点结束后的对调
              console.warn('拖拽结束: ', el);
            }
          });
        }
      }
      // 初始化连线
      for (let i = 0; i < this.data.lineList.length; i++) {
        const line = this.data.lineList[i];
        const connParam = {
          source: line.from,
          target: line.to,
          label: line.label ? line.label : '',
          // connector: 'Bezier',
          connector: line.connector ? line.connector : '',
          anchors: line.anchors ? line.anchors : undefined,
          paintStyle: line.paintStyle ? line.paintStyle : undefined
        };
        this.jsPlumb.connect(connParam, this.jsplumbConnectOptions);
      }
      this.$nextTick(function bar() {
        this.loadEasyFlowFinish = true;
      });
    },
    // 设置连线条件
    setLineLabel(from, to, label) {
      const conn = this.jsPlumb.getConnections({
        source: from,
        target: to
      })[0];
      if (!label || label === '') {
        conn.removeClass('flowLabel');
        conn.addClass('emptyFlowLabel');
      } else {
        conn.addClass('flowLabel');
      }
      label = label.join(',');
      conn.setLabel({
        label
      });
      this.data.lineList.forEach((line) => {
        if (line.from === from && line.to === to) {
          line.label = label;
        }
      });
    },
    // 删除激活的元素
    deleteElement() {
      if (this.activeElement.type === 'node') {
        this.deleteNode(this.activeElement.nodeId, this.activeElement.name);
      } else if (this.activeElement.type === 'line') {
        this.$confirm('确定删除所点击的线吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const conn = this.jsPlumb.getConnections({
            source: this.activeElement.sourceId,
            target: this.activeElement.targetId
          })[0];
          this.jsPlumb.deleteConnection(conn);
        }).catch(() => {
        });
      }
    },
    // 删除线
    deleteLine(from, to) {
      this.data.lineList = this.data.lineList.filter((line) => {
        if (line.from === from && line.to === to) {
          return false;
        }
        return true;
      });
    },
    // 改变连线
    changeLine(oldFrom, oldTo) {
      this.deleteLine(oldFrom, oldTo);
    },
    // 改变节点的位置
    changeNodeSite(data) {
      for (let i = 0; i < this.data.nodeList.length; i++) {
        const node = this.data.nodeList[i];
        if (node.id === data.nodeId) {
          node.left = data.left;
          node.top = data.top;
        }
      }
    },
    /**
    * 拖拽结束后添加新的节点
    * @param evt
    * @param nodeMenuVo 被添加的节点对象
    * @param mousePosition 鼠标拖拽结束的坐标
    */
    addNode(evt, nodeMenuVo, mousePosition) {
      console.warn(mousePosition);
      let left = evt.originalEvent.clientX;
      let top = evt.originalEvent.clientY;
      const efContainer = this.$refs.efContainer;
      const containerRect = efContainer.getBoundingClientRect();
      // 计算是否拖入到容器中
      if (left < containerRect.x || left > containerRect.width + containerRect.x || top < containerRect.y || containerRect.y > containerRect.y + containerRect.height) {
        this.$message.error('请把节点拖入到画布中');
        return;
      }
      const nodeList = this.data.nodeList;
      const id = nodeMenuVo.id;
      if (id === '0' || id === '1') {
        for (let i = 0; i < nodeList.length; i++) {
          if ((id.indexOf(nodeList[i].templateId) > -1) && id === '0') {
            this.$message.error('开始节点已存在');
            return;
          }
          if ((id.indexOf(nodeList[i].templateId) > -1) && id === '1') {
            this.$message.error('结束节点已存在');
            return;
          }
        }
      }
      left -= containerRect.x;
      left += efContainer.scrollLeft;
      top -= containerRect.y;
      top += efContainer.scrollTop;
      // 居中
      left -= 85;
      top -= 16;
      const nodeId = this.getUUID();
      // 动态生成名字
      const origName = nodeMenuVo.name;
      let nodeName = origName;
      let index = 1;
      while (index < 10000) {
        let repeat = false;
        for (let i = 0; i < this.data.nodeList.length; i++) {
          const node = this.data.nodeList[i];
          if (node.name === nodeName) {
            nodeName = origName;
            repeat = true;
          }
        }
        if (repeat) {
          index++;
          // eslint-disable-next-line no-continue
          continue;
        }
        break;
      }
      const node = {
        id: nodeId,
        templateId: nodeMenuVo.id,
        name: nodeName,
        type: nodeMenuVo.type,
        left: `${left}px`,
        top: `${top}px`,
        ico: nodeMenuVo.ico,
        state: 'success',
        filePath: nodeMenuVo.filePath,
        content: nodeMenuVo.content
      };
      /**
        * 这里可以进行业务判断、是否能够添加该节点
        */
      this.data.nodeList.push(node);
      this.$nextTick(function bar() {
        this.jsPlumb.makeSource(nodeId, this.jsplumbSourceOptions);
        this.jsPlumb.makeTarget(nodeId, this.jsplumbTargetOptions);
        this.jsPlumb.draggable(nodeId, {
          containment: 'parent',
          stop(el) {
            // 拖拽节点结束后的对调
            console.warn('拖拽结束: ', el);
          }
        });
      });
    },
    /**
     * 删除节点
     * @param nodeId 被删除节点的ID
     */
    deleteNode(nodeId, name) {
      this.$confirm(`确定要删除节点${name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        /**
         * 这里需要进行业务判断，是否可以删除
         */
        this.data.nodeList = this.data.nodeList.filter((node) => {
          if (node.id === nodeId) {
            // 伪删除，将节点隐藏，否则会导致位置错位
            // node.show = false
            return false;
          }
          return true;
        });
        // this.$nextTick(function () {
        //   this.jsPlumb.removeAllEndpoints(nodeId);
        // });
      }).catch(() => {
      });
      return true;
    },
    clickNode(nodeId) {
      this.activeElement.type = 'node';
      this.activeElement.nodeId = nodeId;
      this.data.nodeList.forEach((node) => {
        if (node.id === nodeId) {
          this.activeElement.name = node.name;
        }
      });
      this.$refs.nodeForm.nodeInit(this.data, nodeId);
    },
    // 是否具有该线
    hasLine(from, to) {
      for (let i = 0; i < this.data.lineList.length; i++) {
        const line = this.data.lineList[i];
        if (line.from === from && line.to === to) {
          return true;
        }
      }
      return false;
    },
    // 是否含有相反的线
    hashOppositeLine(from, to) {
      return this.hasLine(to, from);
    },
    nodeRightMenu(nodeId, evt) {
      this.menu.show = true;
      this.menu.curNodeId = nodeId;
      this.menu.left = `${evt.x}px`;
      this.menu.top = `${evt.y}px`;
    },
    repaintEverything() {
      this.jsPlumb.repaint();
    },
    // 流程数据信息
    dataInfo() {
      this.flowInfoVisible = true;
      this.$nextTick(function bar() {
        this.$refs.flowInfo.init();
      });
    },
    // 加载流程图
    dataReload(data) {
      this.easyFlowVisible = false;
      this.data.nodeList = [];
      this.data.lineList = [];
      this.$nextTick(() => {
        data = lodash.cloneDeep(data);
        this.easyFlowVisible = true;
        this.data = data;
        this.$nextTick(() => {
          // eslint-disable-next-line no-undef
          this.jsPlumb = jsPlumb.getInstance();
          this.$nextTick(() => {
            this.jsPlumbInit();
          });
        });
      });
    },
    // 模拟载入数据dataA
    dataReloadA() {
      this.dataReload(this.dataA);
    },
    // 模拟载入数据dataB
    dataReloadB() {
      this.dataReload(this.dataB);
    },
    // 模拟载入数据dataC
    dataReloadC() {
      this.dataReload(this.dataC);
    },
    zoomAdd() {
      if (this.zoom >= 1) {
        return;
      }
      this.zoom = this.zoom + 0.1;
      this.$refs.efContainer.style.transform = `scale(${this.zoom})`;
      this.jsPlumb.setZoom(this.zoom);
    },
    zoomSub() {
      if (this.zoom <= 0) {
        return;
      }
      this.zoom = this.zoom - 0.1;
      this.$refs.efContainer.style.transform = `scale(${this.zoom})`;
      this.jsPlumb.setZoom(this.zoom);
    },
    // 下载数据
    downloadData() {
      this.$confirm('确定要下载该流程数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        const datastr = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(this.data, null, '\t'))}`;
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', datastr);
        downloadAnchorNode.setAttribute('download', 'data.json');
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
        this.$message.success('正在下载中,请稍后...');
      }).catch(() => {
      });
    },
    openHelp() {
      this.flowHelpVisible = true;
      this.$nextTick(function bar() {
        this.$refs.flowHelp.init();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/engine/panel.vue